export function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Strategy Call',
      description: 'We start with a consultation to understand your book idea, goals, and audience.'
    },
    {
      number: '02',
      title: 'Manuscript & Editing',
      description: 'Our editorial team works with you to refine your manuscript and prepare it for publishing.'
    },
    {
      number: '03',
      title: 'Design & Production',
      description: 'We design your cover, format your book, and prepare it for distribution.'
    },
    {
      number: '04',
      title: 'Publishing & Launch',
      description: 'Your book is published and available to readers worldwide.'
    }
  ];

  return (
    <section id="process" className="bg-gradient-to-b from-black via-[#0A0A0A] to-black py-28">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-20">
          <div className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-medium mb-4">
            How It Works
          </div>
          <h2 className="text-white text-5xl font-bold mb-5">
            Our Simple Publishing Process
          </h2>
          <div className="w-20 h-1 bg-[#D4AF37] rounded-full mx-auto"></div>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="absolute top-20 left-0 right-0 h-0.5 bg-gradient-to-r from-[#D4AF37]/0 via-[#D4AF37]/30 to-[#D4AF37]/0 hidden lg:block"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-gradient-to-br from-[#1C1C1C] to-[#0F0F0F] rounded-2xl p-8 border border-[#D4AF37]/10 hover:border-[#D4AF37]/30 transition-all duration-300 h-full">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#D4AF37]/10 border-2 border-[#D4AF37] mb-6 mx-auto">
                    <span className="text-[#D4AF37] text-2xl font-bold">{step.number}</span>
                  </div>
                  <h3 className="text-white text-xl font-semibold mb-4 text-center">
                    {step.title}
                  </h3>
                  <p className="text-[#999999] text-base leading-relaxed text-center">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}